import type { MarketGroupsApi } from "@/v2/api/metadata/market-groups";
import type { MarketsApi } from "@/v2/api/metadata/markets";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { DialogConfig } from "@/v2/framework/dialog/types";
import { readApiData } from "@/v2/api/response";
import { createConfigurationTab } from "./tabs/configuration";
import { createLiveTab } from "./tabs/live";
import { createMainTab } from "./tabs/main";
import { createPrematchTab } from "./tabs/prematch";
import { createTranslationsTab } from "./tabs/translations";

export function createEditDialog(options: {
  ctx: BackofficeContext;
  marketGroupsApi: MarketGroupsApi;
  marketsApi: MarketsApi;
}): DialogConfig {
  const { ctx, marketGroupsApi, marketsApi } = options;

  return {
    id: "edit-market-group",
    title: "Edit market group",
    layout: { type: "popover" },
    api: {
      initialValues: async (row) => {
        const data = readApiData(await marketGroupsApi.getSingle(row.id));
        return (data && typeof data === "object" && !Array.isArray(data) ? data : {}) as Record<
          string,
          unknown
        >;
      },
      submit: async () => {},
    },
    structure: {
      type: "tabbed",
      savePerTab: true,
      tabs: [
        createMainTab({ marketGroupsApi, marketsApi }),
        createPrematchTab(marketGroupsApi),
        createLiveTab(marketGroupsApi),
        createTranslationsTab({ ctx, marketGroupsApi }),
        createConfigurationTab(marketGroupsApi),
      ],
    },
  };
}
